import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import Spinner from "../components/Spinner";

const LandingPage = lazy(() => import("../pages/LandingPage/LandingPage"));
const Login = lazy(() => import("../pages/Auth/Login/Login"));
const Signup = lazy(() => import("../pages/Auth/Signup"));
const PageNotFound = lazy(() => import("../pages/PageNotFound"));
const AdminLogin = lazy(() => import("../pages/Admin/Auth/AdminLogin"));
const Dashboard = lazy(() => import("../pages/Admin/Dashboard/Dashboard"));
const RejectedConsumerKYC = lazy(() => import("../pages/RejectedConsumerKYC"));
const PendingConsumerKYC = lazy(() => import("../pages/PendingConsumerKYC"));
const DirectoryList = lazy(() => import("../pages/Directory/DirectoryList"));
const PlatformSelection = lazy(() => import("../pages/PlatformSelection"));

const AppRouter = () => {
  const consumerKycStatusId = useSelector((state) => state?.user?.userData?.consumerKycStatusId);
  const userRole = useSelector((state) => state?.user?.userData?.loggedIn);

  return (
    <div>
      <Suspense fallback={<Spinner />}>
        <Routes>
          <Route exact path="/" element={<LandingPage />} />
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/admin/login"
            element={
              <PublicRoute>
                <AdminLogin />
              </PublicRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute role="Admin">
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {consumerKycStatusId === 2 && (
            <>
              <Route
                path="/directory"
                element={
                  <ProtectedRoute role="Customer">
                    <DirectoryList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/platforms"
                element={
                  <ProtectedRoute role="Customer">
                    <PlatformSelection />
                  </ProtectedRoute>
                }
              />
            </>
          )}
          {(!consumerKycStatusId || consumerKycStatusId === 1 || consumerKycStatusId === 4) && <Route path="*" element={<Signup />} />}
          {/* {consumerKycStatusId === 1 && <Route path="*" element={<PendingConsumerKYC />} />} */}
          {(consumerKycStatusId === 2 || userRole === "Admin") && <Route path="*" element={<PageNotFound />} />}
          {consumerKycStatusId === 3 && <Route path="*" element={<RejectedConsumerKYC />} />}
        </Routes>
      </Suspense>
    </div>
  );
};

export default AppRouter;
